import React, { FC } from "react";
import Tooltip from "rc-tooltip";
import "rc-tooltip/assets/bootstrap.css";
import { CloseIcon } from "@chakra-ui/icons";

type CloseButtonProps = {
	onClick: () => void;
	disabled: boolean;
	tooltipText: string;
	tooltipId: string;
	className?: string;
};

export const CloseButton: FC<CloseButtonProps> = (props) => {
	const onClick = () => {
		if (props.disabled) return;
		if (!props.onClick) {
			console.error("No onClick function set for CloseButton");
			return;
		}
		props.onClick();
	};

	const buttonProps = { "aria-describedby": "" };
	const hasTooltip = !props.disabled && props.tooltipText !== undefined;
	if (hasTooltip && props.tooltipId) buttonProps["aria-describedby"] = props.tooltipId;
	const buttonComponent = (
		<CloseIcon
			onClick={onClick}
			className={props.className}
			opacity={props.disabled ? 0.5 : 1}
			color={"#666666"}
			margin={2}
			padding={0}
			boxSize={3}
			cursor={"pointer"}
			{...buttonProps}
		/>
	);

	return hasTooltip ? (
		<Tooltip
			placement="bottom"
			trigger={["hover"]}
			id={props.tooltipId}
			destroyTooltipOnHide={true}
			overlayClassName="Tooltip"
			overlay={<span>{props.tooltipText}</span>}
		>
			{buttonComponent}
		</Tooltip>
	) : (
		buttonComponent
	);
};
